import { createContext, useState } from "react";
export const CommonContext = createContext();
import userImg from "../assets/user.png";
import upload_icon from "../assets/upload_icon.png";
import loader_img from "../assets/loader_img.gif";
import loader2 from "../assets/loader.gif";

export const IMAGE_MAX_MB = 15;
export const VIDEO_MAX_MB = 300;
const CommonContextProvider = ({ children }) => {
  /* sidebar @start */
  const [sidebarAct, setSidebarAct] = useState(false);
  /* sidebar @end */

  /* blocks @start */
  const [addBlock, setAddBlock] = useState(false);
  const [isEditBlock, setIsEditBlock] = useState(null);
  const [workingBlockName, setWorkingBlockName] = useState(null);
  const [blockLists, setBlockLists] = useState([]);
  const [activeBlockLists, setActiveBlockLists] = useState([]);
  /* blocks @end */

  /* fields @start */
  const [addField, setAddField] = useState(false);
  const [isEditField, setIsEditField] = useState(null);
  /* fields @end */

  /* records @start */
  const [addRecord, setAddRecord] = useState(false);
  const [recordDetail, setRecordDetail] = useState(false);
  const [singleRecord, setSingleRecord] = useState(false);
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [recordDynamicRoute, setRecordDynamicRoute] = useState("records");
  const [relationalFieldId, setRelationalFieldId] = useState(null);
  const [relationalBlockId, setRelationalBlockId] = useState(null);
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const [addMoney, setAddMoney] = useState(false);
  const [rfid, setrfid] = useState(null);
  const [recordNavigationStack, setRecordNavigationStack] = useState([]);
  /* records @end */

  /* members @start */
  const [newInviteMember, setNewInviteMember] = useState(false);
  const [pandingInvites, setPandingInvites] = useState(false);
  const [isEditUser, setIsEditUser] = useState(null);
  const [filterRecords, setFilterRecords] = useState({});
  /* members  @end */

  /* client @start */
  const [addClient, setAddClient] = useState(false);
  const [isEditClient, setIsEditClient] = useState(null);
  /* client @end */

  /* permissions @start */
  const [newPermission, setNewPermission] = useState(false);
  const [allowPrimissionAct, setAllowPrimissionAct] = useState(false);
  const [isEditPermission, setIsEditPermission] = useState(null);
  const [permissionList, setPermissionList] = useState([]);
  /* permissions @end */

  /* role @start */
  const [createRolesAct, setCreateRolesAct] = useState(false);
  const [isEditRole, setIsEditRole] = useState(null);
  const [roleId, setRoleId] = useState(null);
  /* role @end */

  /* warehouse @start */
  const [createWarehouseAct, setCreateWarehouseAct] = useState(false);
  const [isEditWarehouse, setIsEditWarehouse] = useState(null);
  /* warehouse @end */

  /* inventory @start */
  const [createInventoryAct, setCreateInventoryAct] = useState(false);
  const [isEditInventory, setIsEditInventory] = useState(null);
  /* inventory @end */
  /* inbound @start */
  const [createInboundAct, setCreateInboundAct] = useState(false);
  const [isEditInbound, setIsEditInbound] = useState(null);
  /* inbound @end */
  /* outbound dispatch @start */
  const [createDispatchAct, setCreateDispatchAct] = useState(false);
  const [isEditDispatch, setIsEditDispatch] = useState(null);
  /* outbound dispatch @end */
  /* order management @start */
  const [createOrderAct, setCreateOrderAct] = useState(false);
  const [isEditOrder, setIsEditOrder] = useState(null);
  /* order management @end */
  /* delete @start */
  const [confirmDeleteAct, setConfirmDeleteAct] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteModule, setDeleteModule] = useState(null);
  const [deletePopupMessage, setDeletePopupMessage] = useState(null);
  /* delete @end */

  /* dropzone @start */
  const [dropzoneAct, setDropzoneAct] = useState(null);
  const [files, setFiles] = useState([]);
  const [maxMb, setMaxMb] = useState(300);
  const [maxFile, setMaxFile] = useState(10);
  const [filterFields, setFilterFields] = useState([]);
  const [filesFieldName, setFilesFieldName] = useState("");
  const [selectDate, setSelectDate] = useState(null);
  const [attachmentFieldName, setAttachmentFieldName] = useState(null);

  /* dropzone @end */

  /* ralationship @start */
  const [addRelationship, setAddRelationship] = useState(false);
  const [relationShipActiveTab, setRelationShipActiveTab] = useState("");
  const [relationshipFields, setRelationshipFields] = useState([]);
  const [qrDetail, setQrDetail] = useState(null);
  const [refreshRelation, setRefreshRelation] = useState(false);
  /* ralationship @end */

  /* third party services API @start */
  const [allVehicles, setAllVehicles] = useState([]);
  /* third party services API @end */

  // QRCodePopup

  const [qrCodePopupAct, setQrCodePopupAct] = useState(false);
  const [qrCodePopupImage, setQrCodePopupImage] = useState("");

  // QRCodePopup

  // Geofence
  const [geofenceFormAct, setGeofenceFormAct] = useState(false);
  const [handleGeofenceData, setHandleGeofenceData] = useState();
  const [geofenceCircleInfo, setGeofenceCircleInfo] = useState({
    type: "meter",
    value: "",
    address: "",
  });

  const [formData, setFormData] = useState({
    vehicle: [],
    zone: "",
    address: "",
    latitude: "",
    longitude: "",
    radius: 0,
  });

  const [selectedPoint, setSelectedPoint] = useState(null);
  const [calculatedRadius, setCalculatedRadius] = useState(0);
  const [selectAddress, setSelectAddress] = useState("");

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(10);
  const [selectedChildBlock, setSelectedChildBlock] = useState(null); // Track selected child block


  // Geofence

  const value = {
    /* sidebar @start */
    sidebarAct,
    setSidebarAct,
    /* sidebar @end */

    /* block @start */
    addBlock,
    setAddBlock,
    isEditBlock,
    setIsEditBlock,
    workingBlockName,
    setWorkingBlockName,
    blockLists,
    setBlockLists,
    activeBlockLists,
    setActiveBlockLists,
    /* block @end */

    /* fields @start */
    addField,
    setAddField,
    isEditField,
    setIsEditField,
    /* fields @end */

    /* records @start */
    addRecord,
    setAddRecord,
    isEditRecord,
    setIsEditRecord,
    recordDetail,
    setRecordDetail,
    singleRecord,
    setSingleRecord,
    recordDynamicRoute,
    setRecordDynamicRoute,
    relationalFieldId,
    setRelationalFieldId,
    relationalBlockId,
    setRelationalBlockId,
    showCarousel,
    setShowCarousel,
    carouselImages,
    setCarouselImages,
    startIndex,
    setStartIndex,
    addMoney,
    setAddMoney,
    rfid,
    setrfid,
    selectedChildBlock,
    setSelectedChildBlock,
    recordNavigationStack,
    setRecordNavigationStack,
    /* records @end */

    /* members @start */
    setNewInviteMember,
    newInviteMember,
    pandingInvites,
    setPandingInvites,
    isEditUser,
    setIsEditUser,
    /* members @end */

    /* permissions @start */
    setNewPermission,
    newPermission,
    isEditPermission,
    setIsEditPermission,
    setAllowPrimissionAct,
    allowPrimissionAct,
    permissionList,
    setPermissionList,
    /* permissions @end */

    /* client @start */
    addClient,
    setAddClient,
    isEditClient,
    setIsEditClient,
    /* client @end */

    /* role @start */
    createRolesAct,
    setCreateRolesAct,
    isEditRole,
    setIsEditRole,
    roleId,
    setRoleId,
    /* role @end */

    /* warehouse @start */
    createWarehouseAct,
    setCreateWarehouseAct,
    isEditWarehouse,
    setIsEditWarehouse,
    /* warehouse @end */
    /* inventory @start */
    createInventoryAct,
    setCreateInventoryAct,
    isEditInventory,
    setIsEditInventory,
    /* inventory @end */

    /* inbound @start */
    createInboundAct,
    setCreateInboundAct,
    isEditInbound,
    setIsEditInbound,
    /* inbound @end */
    /* outbound dispatch @start */
    createDispatchAct,
    setCreateDispatchAct,
    isEditDispatch,
    setIsEditDispatch,
    /* outbound dispatch @end */
    /* order management @start */
    createOrderAct,
    setCreateOrderAct,
    isEditOrder,
    setIsEditOrder,
    /* order management @end */
    /* delete @start */
    confirmDeleteAct,
    setConfirmDeleteAct,
    deleteId,
    setDeleteId,
    deleteModule,
    setDeleteModule,
    deletePopupMessage,
    setDeletePopupMessage,

    setFilterRecords,
    filterRecords,
    /* delete @end */

    // QRCodePopup

    qrCodePopupAct,
    setQrCodePopupAct,
    qrCodePopupImage,
    setQrCodePopupImage,

    // QRCodePopup

    /* images @start */
    userImg,
    upload_icon,

    /* images @end */

    /* dropzone @start */
    dropzoneAct,
    setDropzoneAct,
    setFiles,
    files,
    maxMb,
    setMaxMb,
    maxFile,
    setMaxFile,
    filterFields,
    setFilterFields,
    filesFieldName,
    setFilesFieldName,
    selectDate,
    setSelectDate,
    attachmentFieldName,
    setAttachmentFieldName,
    /* dropzone @end */

    /* ralationship @start */
    setAddRelationship,
    addRelationship,
    relationShipActiveTab,
    setRelationShipActiveTab,
    relationshipFields,
    setRelationshipFields,
    refreshRelation,
    setRefreshRelation,
    /* ralationship @end */
    loader_img,
    loader2,
    qrDetail,
    setQrDetail,
    /* third party services API @start */
    allVehicles,
    setAllVehicles,
    /* third party services API @end */

    // GeoFence
    geofenceFormAct,
    setGeofenceFormAct,
    handleGeofenceData,
    setHandleGeofenceData,
    geofenceCircleInfo,
    setGeofenceCircleInfo,
    formData,
    setFormData,
    selectedPoint,
    setSelectedPoint,
    calculatedRadius,
    setCalculatedRadius,
    selectAddress,
    setSelectAddress,
    mapCenter,
    setMapCenter,
    mapZoom,
    setMapZoom,
    // GeoFence
  };
  return (
    <CommonContext.Provider value={value}>{children}</CommonContext.Provider>
  );
};

export default CommonContextProvider;